import React from 'react'
import g from '../component/ui/GradientBackground.module.css'
import d18 from './HomeworkButler.module.css'

import tanqLogo from '../component/media/questa logo white.png'

import {BsWhatsapp} from 'react-icons/bs'
function HomeworkButler() {
    return (<>
        <div className={d18.chatContainer}>
        <img alt='logo' className={d18.logo} src={tanqLogo ||'https://firebasestorage.googleapis.com/v0/b/tanq-7bdfc.appspot.com/o/media%2Ftanq%20logo%20white.png?alt=media&token=6203dcb0-9a38-4ca2-8091-acaca101b895'}/>

 <div> <p>  Got any suggestions? </p>
          <p> Got any new ideas? </p>
          <p>  We would love to hear them </p></div>
            <div className={d18.context}>
         
            <a href='https://wa.me/message/EQMDVYMG5NXJK1'>Chat with Us <BsWhatsapp/> </a>
     </div>
        </div>
        
        <div className={g.body}>   
            <ul className={g.circles}>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
    </div >
 </>   )
}

export default HomeworkButler
